import {
  RESET_COMPLETE_COMPANY_DATA,
  SET_COMPLETE_COMPANY_DATA,
  SET_EMAIL_PERSIST,
  RESET_EMAIL_PERSIST,
  SET_COMPANY_FORM_VALIDATION,
  RESET_COMPANY_FORM_VALIDATION,
  SET_COMPANY_DATA,
  RESET_COMPANY_DATA,
  SET_SEND_COMPANY_DATA,
  RESET_SEND_COMPANY_DATA,
  SET_LEAD_DATA,
  RESET_LEAD_DATA,
  SET_LEAD_CREATED,
  RESET_LEAD_CREATED,
  HAS_SUB_COMPANIES,
  SET_SUB_COMPANIES,
  RESET_HIRING_ALL,
  SET_SUB_COMPANIES_VALID,
  SET_SUB_COMPANIES_ENTRY_VALID,
  SET_SELECT_ADMIN_VALIDATION,
  RESET_SELECT_ADMIN_VALIDATION,
  SET_ADMIN_FORM_VALIDATION,
  RESET_ADMIN_FORM_VALIDATION,
  SET_ADMIN_DEFAULT,
  SET_ADMIN_DATA,
  RESET_ADMIN_DATA,
  RESET_IS_INCORPORATION_RANGE,
  SET_IS_INCORPORATION_RANGE,
  SET_FINAL_CONFIRMATION_DATA,
} from './actionTypes';

// Form
export const setCompanyFormValidation = (payload: any) => ({
  type: SET_COMPANY_FORM_VALIDATION,
  payload,
});

export const resetCompanyFormValidation = () => ({
  type: RESET_COMPANY_FORM_VALIDATION,
});

export const setEmailPersist = (payload: any) => ({
  type: SET_EMAIL_PERSIST,
  payload,
});

export const resetEmailPersist = () => ({
  type: RESET_EMAIL_PERSIST,
});

export const setCompanyData = (payload: any) => ({
  type: SET_COMPANY_DATA,
  payload,
});

export const resetCompanyData = () => ({
  type: RESET_COMPANY_DATA,
});

export const setSendCompanyData = (payload: any) => ({
  type: SET_SEND_COMPANY_DATA,
  payload,
});

export const resetSendCompanyData = () => ({
  type: RESET_SEND_COMPANY_DATA,
});

export const setLeadData = (payload: any) => ({
  type: SET_LEAD_DATA,
  payload,
});

export const resetLeadData = () => ({
  type: RESET_LEAD_DATA,
});

export const setLeadCreated = (payload: any) => ({
  type: SET_LEAD_CREATED,
  payload,
});

export const resetLeadCreated = () => ({
  type: RESET_LEAD_CREATED,
});

export const hasSubCompanies = (payload: any) => ({
  type: HAS_SUB_COMPANIES,
  payload,
});

export const setSubCompanies = (payload: any) => ({
  type: SET_SUB_COMPANIES,
  payload,
});

export const resetAllHiring = () => ({
  type: RESET_HIRING_ALL,
});

export const setIsSubCompaniesValid = (payload: any) => ({
  type: SET_SUB_COMPANIES_VALID,
  payload,
});

export const setIsSubCompaniesEntryValid = (payload: any) => ({
  type: SET_SUB_COMPANIES_ENTRY_VALID,
  payload,
});

export const setSelectAdminValidation = (payload: any) => ({
  type: SET_SELECT_ADMIN_VALIDATION,
  payload,
});

export const resetSelectAdminValidation = () => ({
  type: RESET_SELECT_ADMIN_VALIDATION,
});

export const setAdminFormValidation = (payload: any) => ({
  type: SET_ADMIN_FORM_VALIDATION,
  payload,
});

export const resetAdminFormValidation = () => ({
  type: RESET_ADMIN_FORM_VALIDATION,
});

export const setAdminDefault = (payload: any) => ({
  type: SET_ADMIN_DEFAULT,
  payload,
});

export const setAdminData = (payload: any) => ({
  type: SET_ADMIN_DATA,
  payload,
});

export const resetAdminData = () => ({
  type: RESET_ADMIN_DATA,
});

export const setCompleteCompanyData = (payload: any) => ({
  type: SET_COMPLETE_COMPANY_DATA,
  payload,
});

export const resetCompleteCompanyData = () => ({
  type: RESET_COMPLETE_COMPANY_DATA,
});

export const setIsIncorporationRange = (payload: any) => ({
  type: SET_IS_INCORPORATION_RANGE,
  payload,
});

export const resetIsIncorporationRange = () => ({
  type: RESET_IS_INCORPORATION_RANGE,
});

export const setFinalConfirmationData = (payload: any) => ({
  type: SET_FINAL_CONFIRMATION_DATA,
  payload,
});
